// Mounts the platform-provided job-list route config at /jobs.

import { jobListRoute } from '@podium/platform/routes'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/jobs')(jobListRoute)
